module.exports = __webpack_public_path__ + "img/img-3.3b47bf3d.webp";